import { Reducer } from 'redux'
import { ICoverLoadState, ICoverResponseData } from 'apps/booking/types'
import { COVER_LOAD_ACTION_TYPES as c } from 'apps/booking/utils/actions/coverLoad'

const initState: ICoverLoadState = {
  data: undefined,
  loadingCreate: false,
  loadingUpdate: false,
  error: '',
}

interface CoverLoadResponsePayload {
  shipment: {
    coveredBid: ICoverResponseData
  }
}
type CoverActions =
  | { type: c.CREATE_COVER_REQUEST }
  | { type: c.CREATE_COVER_SUCCESS; payload: CoverLoadResponsePayload }
  | { type: c.CREATE_COVER_FAILURE; error: string }
  | { type: c.UPDATE_COVER_REQUEST }
  | { type: c.UPDATE_COVER_SUCCESS; payload: CoverLoadResponsePayload }
  | { type: c.UPDATE_COVER_FAILURE; error: string }
  | { type: c.CLEAR_COVER_LOAD_ERROR }
  | { type: c.CLEAR_COVER_LOAD_DATA }

const coverLoadReducer: Reducer<ICoverLoadState, CoverActions> = (
  state: ICoverLoadState = initState,
  action: CoverActions
): ICoverLoadState => {
  switch (action.type) {
    case c.CREATE_COVER_REQUEST: {
      return {
        ...state,
        loadingCreate: true,
      }
    }
    case c.CREATE_COVER_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        data: action.payload.shipment.coveredBid,
      }
    case c.CREATE_COVER_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.error,
      }
    case c.UPDATE_COVER_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        data: action.payload.shipment.coveredBid,
      }
    case c.UPDATE_COVER_REQUEST:
      return {
        ...state,
        loadingUpdate: true,
      }
    case c.UPDATE_COVER_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.error,
      }
    case c.CLEAR_COVER_LOAD_ERROR:
      return {
        ...state,
        loadingUpdate: false,
        error: initState.error,
      }
    case c.CLEAR_COVER_LOAD_DATA:
      return {
        ...state,
        ...initState,
      }
    default:
      return state
  }
}

export default coverLoadReducer
